import React, { useEffect, useRef, useState } from 'react'

// Official XCEED widget loader per XCEED Support: How to install the XCEED Widget
// https://support.xceed.me – Settings > Widget > Website Domain must include your site URL
const XCEED_WIDGET_SCRIPT_ID = 'xceed-widget-loader'
const XCEED_WIDGET_LOADER_URL = 'https://s3-eu-west-1.amazonaws.com/xceed-widget/2019-version/dist/loader.js'

const XceedWidget = () => {
  const widgetRef = useRef(null)
  const [isLocalhost] = useState(() =>
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  )

  useEffect(() => {
    if (isLocalhost) return

    const existingScript = document.getElementById(XCEED_WIDGET_SCRIPT_ID)
    if (existingScript) existingScript.remove()

    const script = document.createElement('script')
    script.id = XCEED_WIDGET_SCRIPT_ID
    script.src = XCEED_WIDGET_LOADER_URL
    script.type = 'text/javascript'
    document.body.appendChild(script)

    return () => {
      const scriptToRemove = document.getElementById(XCEED_WIDGET_SCRIPT_ID)
      if (scriptToRemove) scriptToRemove.remove()
      if (widgetRef.current) widgetRef.current.innerHTML = ''
    }
  }, [])

  if (isLocalhost) {
    return (
      <div
        id="xceed-widget"
        ref={widgetRef}
        style={{
          padding: '40px 20px',
          backgroundColor: '#1a1a1a',
          borderRadius: '4px',
          textAlign: 'center',
          color: '#aaa'
        }}
      >
        <p style={{ margin: '0 0 8px' }}>Ticket widget is not loaded on localhost.</p>
        <p style={{ margin: 0, fontSize: '0.9rem' }}>
          Add your site URL in <strong>XCEED Pro → Settings → Widget → Website Domain</strong> for the widget to appear in production.
        </p>
      </div>
    )
  }

  return <div id="xceed-widget" ref={widgetRef} />
}

export default XceedWidget
